<script>
  import { linkResolver } from "$lib/prismic";
  import Text from "$lib/Text.svelte";

  export let block;

  const {
    text,
    button_text,
    button_link,
    background_color: background = "black",
  } = block.primary;
</script>

<div
  class="w-screen overflow-hidden relative transition duration-300 {background ===
  'black'
    ? 'dark'
    : background === 'white'
    ? 'light'
    : 'gradient dark'}"
>
  <div class="max-w-4xl mx-auto p-16 lg:p-24">
    <Text {text} />
    {#if button_text}
      <a
        class="btn mt-4"
        href={button_link.url || linkResolver(button_link._meta)}
        target={button_link.target}>{button_text}</a
      >
    {/if}
  </div>
</div>
